import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import ProgressWrapDiv from "../../components/common/ProgressWrapDiv";
import TextArea from "../../components/common/TextArea";
import TextBoxArea from "../../components/common/TextBoxArea";
import FunctionButton from "../../components/common/FunctionButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import { useTranslation } from "react-i18next";

const RegConfirmPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const email = location.state?.email;

  useEffect(() => {
    if (!email) {
      navigate("/login");
    }
  }, []);

  const handleNextClick = () => {
    navigate("/login");
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("L0341"), t("L0342")]}></BreadCrumbDiv>

      <ProgressWrapDiv>
        <li>{`01 ${t("L0344")}`}</li>
        <li>{`02 ${t("L0345")}`}</li>
        <li className="active">{`03 ${t("L0346")}`}</li>
      </ProgressWrapDiv>

      <TextArea className={"ptb100"}>
        <h1 className="pb20">{t("L0361")}</h1>
        <h4>{t("L0362")}</h4>
      </TextArea>
      <TextBoxArea className={"pp40"}>
        <h4 className="pb20">{t("L0363")}</h4>
        <h4>{email}</h4>
      </TextBoxArea>

      <ButtonWrapDiv className="btn_bottom">
        <FunctionButton
          className="big"
          value={t("L0355")}
          onClick={handleNextClick}
        ></FunctionButton>
      </ButtonWrapDiv>
    </div>
  );
};

export default RegConfirmPage;
